import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BaseURL, schoolyearID, uniqueToken } from "../../../api/DataApis";
import request from "../../../Apis/request";
import Swal from "sweetalert2";

function Category() {
  document.title = "Category";
  const [loading, setLoading] = useState(false);
  const [CategoryData, setCategoryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const FetchfiltercategoryData = async () => {
    setLoading(true);

    const url = `${BaseURL}/admin/master/category`;

    try {
      const res = await request({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (res && res?.data) {
        setCategoryData(res?.data);
        setFilteredData(res?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchfiltercategoryData();
  }, []);

 
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = CategoryData.filter((item) =>
      item?.value?.toLowerCase().includes(query)
    );
    setFilteredData(filtered);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header pb-0">
                <div className="d-flex">
                  <div className="col-sm-4 add">
                    <Link
                      className="btn btn-transparent grey-salsa btn-outline btn-circle btn-sm"
                      style={{ width: "auto" }}
                      to="/masters/categorylist/add"
                    >
                      <i className="fa fa-plus"></i> Add Category
                    </Link>
                    <input
                      placeholder="Search"
                      className="form-control text-center"
                      value={searchQuery}
                      onChange={handleSearch}
                      style={{
                        borderRadius: "34px",
                        width: "159px",
                        fontSize: "2.5vh",
                        border: "1px solid #ced4da",
                        position: "relative",
                        top: "18px",
                        transform: "translateX(847px)",
                      }}
                    />
                  </div>
                </div>
                <div>
                  <hr />
                  <h5>All Categories</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display dataTable" id="advance-1">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Category Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData && filteredData.length > 0 ? (
                        filteredData.map((u, i) => (
                          <tr key={u?.hostelID}>
                            <td>{i + 1}</td>
                            <td>{u?.title}</td>
                            <td>{u?.status}</td>
                            <td>
                              <Link to="">
                                <i
                                  className="fa fa-check-square-o"
                                  style={{ fontSize: "18px" }}
                                ></i>{" "}
                              </Link>
                              <Link
                                to={`/hostel/edit/${u?.hostelID}`}
                                state={{ HostelEditData: u }}
                              >
                                <i
                                  className="fa fa-edit"
                                  style={{ fontSize: "18px" }}
                                ></i>{" "}
                              </Link>
                          
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Category;
